import { render, staticRenderFns } from "./CommonLinkCart.vue?vue&type=template&id=524940c4&"
import script from "./CommonLinkCart.vue?vue&type=script&lang=js&"
export * from "./CommonLinkCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports